import { AbstractValidation } from "./AbstractValidation";
import { CustomErrorMessage } from "./ValidationHelper";
import { translate } from "../Locales/translator";

export class EmailValidation extends AbstractValidation {
  key = "isEmail";

  constructor(private readonly required = true, customErrorMessage?: CustomErrorMessage) {
    super(customErrorMessage);
  }

  validate = (value: string) => {
    if (!this.required && (value === "" || value === undefined || value === null)) {
      return true;
    }
    const regexEmail =
      // eslint-disable-next-line
      /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
    return regexEmail.test(value);
  };

  defaultMessage = (label: string): string => translate("Generation_Form_{label}MoetEenGeldigEmailAdresZijn", { label: label });
}
